<template>
  <main id="admin-content">
    <b-container fluid class="login-form-container">
      <div class="full-page-wrap">
        <div class="full-page-content login">
          <img class="logo" src="/static/img/logo.png"/>
          <div class="login-options">
            <div class="user-login-form">
              <button type="button" class="button large -outline expanded ng-scope"
                      @click="loginOauth()">
                Iniciar sesión
              </button>
            </div>
            <a href="https://www.grupoproeduca.com" target="_blank" class="legal" >©{{ new Date().getFullYear() }} Grupo Proeduca. Todos los derechos reservados.</a>
          </div>
        </div>
      </div>
    </b-container>
  </main>
</template>

<script>

export default {
  name: 'LoginAdmin',
  created () {
    this.setCssVariables()
  },
  methods: {
    loginOauth () {
      window.location.href = 'unir-login'
    },
    setCssVariables () {
      document.documentElement.style.setProperty('--color-proeduca', '#c26757')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/LoginAdmin.vue